export const CHANNEL_CODE = 'AGNT_CHNL';

export const AgencyRole = {
  AGENCY_CREATOR: 'AGENCY_CREATOR',
  AGENCY_AM_CANDIDATE: 'AGENCY_CANDIDATE',
  AGENCY_AD: 'AGENCY_AD',
  AGENCY_AOS: 'AGENCY_AOS',
  AGENCY_AOS_HEAD: 'AGENCY_AOS_HEAD',
};

export const CRITERIA = {
  CRITERIA_1: 'CRIT_1',
  CRITERIA_CHALLENGE_1: 'CRIT_CHAL_1',
  CRITERIA_2: 'CRIT_2',
  CRITERIA_CHALLENGE_2: 'CRIT_CHAL_2',
};

export const EAppStatusConstant = {
  RECRUIT_PRCES: 'RECRUIT_PRCES',
  AMC_PRCES: 'AMC_PRCES',
  AMC_REJECT: 'AMC_REJECT',
  AMC_RETURN: 'AMC_RETURN',
  AD_VALID: 'AD_VALID',
  AD_REJECT: 'AD_REJECT',
  AOS_VALID: 'AOS_VALID',
  AOS_RETURN: 'AOS_RETURN',
  ADMIN_APROV: 'ADMIN_APROV',
  ADMIN_VALID: 'ADMIN_VALID',
  ADMIN_RETURN: 'ADMIN_RETURN',
  CANCLED: 'CANCLED',
};

export const EAppSubStatusConstant = {
  INTEGRATE_AGIS_FAIL: 'INTEGRATE_AGIS_FAIL',
  GENERATE_E_CONTRACT_FAIL: 'GENERATE_E_CONTRACT_FAIL',
  GENERATE_E_APPLICATION_FAIL: 'GENERATE_E_APPLICATION_FAIL',
  UPLOAD_FILE_NET_FAIL: 'UPLOAD_FILE_NET_FAIL',
  TRANSACTION_FAIL: 'TRANSACTION_FAIL',
  GENERATE_E_APP_SUCCESSFUL: 'GENERATE_E_APP_SUCCESSFUL',
  INTEGRATE_AGIS_SUCCESSFUL: 'INTEGRATE_AGIS_SUCCESSFUL',
};

export const ControlStatus = {
  EAPP_STATUS: 'EAPP_STATUS',
  DISABLE_SUBMIT_BTN: 'DISABLE_SUBMIT_BTN',
  DISABLE_CANCEL_BTN: 'DISABLE_CANCEL_BTN',
  DISABLE_SAVE_BTN: 'DISABLE_SAVE_BTN',
  DISABLE_REFRESH_BTN: 'DISABLE_REFRESH_BTN',
  DISABLE_CANDIDATE_CRITERIA_FORM: 'DISABLE_CANDIDATE_CRITERIA_FORM',
  DISABLE_WORKING_EXPERIENCE_FORM: 'DISABLE_WORKING_EXPERIENCE_FORM',
  DISABLE_DOCUMENT_FORM: 'DISABLE_DOCUMENT_FORM',
  DISABLE_EAPP_STATUS_FORM: 'DISABLE_EAPP_STATUS_FORM',
  DISABLE_AD_COMMENT_FORM: 'DISABLE_AD_COMMENT_FORM',
  DISABLE_AOS_ASSESSMENT: 'DISABLE_AOS_ASSESSMENT',
  HIDE_EAPP_STATUS: 'HIDE_EAPP_STATUS',
};

export const PROMOTE_AM_TITLE_LOV_CD = ['UM', 'SUM', 'BM', 'SBM'];

export const MAX_ADD_OTHER_DOC_AGENCY = 10;

export const EAppAction = {
  REJECT: 'REJECT',
  REQUEST_MODIFY: 'REQUEST_MODIFY',
};
